// All timestamps in the app render in US Eastern Time. DB stays UTC; this is
// display-only. Single formatter so every render goes through one place.

const ET = "America/New_York";

const DATE_TIME = new Intl.DateTimeFormat("en-US", {
  timeZone: ET,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

const DATE_ONLY = new Intl.DateTimeFormat("en-US", {
  timeZone: ET,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// A datetime with no timezone designator: "2026-06-01 02:37:00" or
// "2026-06-01T02:37:00.123". A trailing "Z" or "+/-HH:MM" offset disqualifies.
const NAIVE_DATETIME = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

function asDate(input: string | Date | null | undefined): Date | null {
  if (!input) return null;
  if (input instanceof Date) return input;
  let s = input.trim();
  // The DB (Postgres via the RDS Data API) returns naive UTC timestamps with
  // no timezone designator, e.g. "2026-06-01 02:37:00". JS parses those as
  // *local* time, which silently no-ops the UTC→ET conversion below and shows
  // the raw UTC clock value relabeled "ET". Pin a naive datetime to UTC first.
  if (NAIVE_DATETIME.test(s)) s = s.replace(" ", "T") + "Z";
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/** YYYY-MM-DD HH:MM ET (no seconds). */
export function formatET(input: string | Date | null | undefined): string {
  const d = asDate(input);
  if (!d) return "—";
  const parts = DATE_TIME.formatToParts(d);
  const lookup: Record<string, string> = {};
  for (const p of parts) lookup[p.type] = p.value;
  return `${lookup.year}-${lookup.month}-${lookup.day} ${lookup.hour}:${lookup.minute} ET`;
}

/** YYYY-MM-DD only, in Eastern. */
export function formatETDate(input: string | Date | null | undefined): string {
  const d = asDate(input);
  if (!d) return "—";
  const parts = DATE_ONLY.formatToParts(d);
  const lookup: Record<string, string> = {};
  for (const p of parts) lookup[p.type] = p.value;
  return `${lookup.year}-${lookup.month}-${lookup.day}`;
}
